import { render, staticRenderFns } from "./communityWechatList.vue?vue&type=template&id=4da2714a&scoped=true"
import script from "./communityWechatList.vue?vue&type=script&lang=js"
export * from "./communityWechatList.vue?vue&type=script&lang=js"
import style0 from "./communityWechatList.vue?vue&type=style&index=0&id=4da2714a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da2714a",
  null
  
)

export default component.exports